"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onTableResizeEnd = exports.onTableResizeStart = void 0;
const onTableResizeStart = (state) => {
    return { ...state, isTableResizing: true };
};
exports.onTableResizeStart = onTableResizeStart;
const onTableResizeEnd = (state, action) => {
    return {
        ...state,
        isTableResizing: false,
        columnResizing: {
            ...state.columnResizing,
            columnWidths: {
                ...action.columnWidths,
            },
        },
    };
};
exports.onTableResizeEnd = onTableResizeEnd;
